module.exports = __webpack_public_path__ + "img/TRANSITIONS-SIGNATURE-7.db8291fc.gif";